// extracted by mini-css-extract-plugin
export default {"container":"style_container__Ips2I","navigatorWrapper":"style_navigatorWrapper__k1ZSm","loadingWrapper":"style_loadingWrapper__J1pXM","contentWrapper":"style_contentWrapper__AkXOs"};